(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications-skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications-skeleton.js');
'use strict';

const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  titles,
  icons
} = svs.myProfile.constants;
const NotificationsSkeleton = () => React.createElement("div", {
  className: "margin-bottom-4"
}, React.createElement(TopHeader, {
  icon: icons.CORRECT,
  title: titles.CORRECT
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 4,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 1
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 2,
  boxWidthProcent: 80,
  topMargin: 1
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 2,
  boxWidthProcent: 80,
  topMargin: 1
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 1
}), React.createElement(TopHeader, {
  icon: icons.PLAYTOGETHER,
  title: titles.PLAYTOGETHER
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 4,
  boxWidthProcent: 100,
  topMargin: 2
}));
svs.myProfile.react.pages.notifications.NotificationsSkeleton = NotificationsSkeleton;

 })(window);